// import { getLocal } from "../plugs/storage";

const { VUE_APP_ENV } = process.env;

const LOGINS = {
  development: "//dev-gateway.worldfarm.com//world-passport",
  qa: "//dev-gateway.worldfarm.com//world-passport"
};
console.log(LOGINS[VUE_APP_ENV]);

// 该配置仅在测试环境生效
export default {
  api: LOGINS[VUE_APP_ENV] + "/mobile/sso/email-login",
  params: {
    // mobile: getLocal("sso_mobile") || "18008086893",
    // mobile: '18008086893',
    // mobile: '18602854102',
    // verifyCode: "8888",
    // account: "123456789@qq.com",
    account: "113@qq.com",
    password: "123456",
    deviceType: "WEB",
    deviceId: "123",
    appId: "WORLD_FARM"
  }
};
